import React from "react";

import getSearchWidgetTranslations from "./searchWidgetTranslations"

import Icon from "src/components/icon";
import QuantitySelector from "src/components/quantitySelector";
import DatePicker from "src/components/aramon/datePicker";
import GuestPicker from "src/components/searchWidgetSection/guestPicker/guestPicker.skibig3";
import DateTime from "src/utils/temporalLuxonUtil";
import CTAButton from "src/components/ctabutton";
import { isRunTime } from "src/utils/isRunTime";
import { ApplicationContext } from "src/context";

type Skibig3SearchWidgetTabProps = {
    tab: string;
    activeTab: string;
    onClick: any;
    icon: string;
    label: string;
}

class Skibig3SearchWidgetTab extends React.Component<Skibig3SearchWidgetTabProps> {
    render() {
        const active = this.props.activeTab == this.props.tab;
        return <>
            <button onClick={this.props.onClick} className={`${active ? "bg-white border-b-[2px] border-b border-b-[#FFB200]" : "bg-white/75"}  p-4 flex-1 flex flex-col gap-2 items-center justify-center searchWidgetText md:min-h-[4rem]`}>
                <Icon width={26} height={26} icon={this.props.icon as any} color="#242426" />
                <span>{this.props.label}</span>
            </button>
        </>
    }
}


class Skibig3SearchWidgetTabs extends React.Component<{activeTab: string, setActiveTab: any}> {
    setActiveTab(tab: string) {
        this.props.setActiveTab(tab);
    }

    render() {
        return <>
            <div className="flex rounded-t-2xl overflow-hidden h-[90px]">
                <Skibig3SearchWidgetTab icon="SkiAndStay" label="Ski & Stay" tab="ski&stay" activeTab={this.props.activeTab} onClick={()=>this.setActiveTab('ski&stay')} />
                <Skibig3SearchWidgetTab icon="SB3Tickets" label="Lift Tickets" tab="tickets" activeTab={this.props.activeTab} onClick={()=>this.setActiveTab('tickets')} />
                <Skibig3SearchWidgetTab icon="SB3Rentals" label="Rentals" tab="rentals" activeTab={this.props.activeTab} onClick={()=>this.setActiveTab('rentals')} />
                <Skibig3SearchWidgetTab icon="SB3Lessons" label="Lessons" tab="lessons" activeTab={this.props.activeTab} onClick={()=>this.setActiveTab('lessons')} />
            </div>
        </>
    }
}


type Skibig3SearchWidgetSkiStayProps = {
    startDate: Date;
    setStartDate: (date: Date) => void;
    endDate: Date;
    setEndDate: (date: Date) => void;
    minimumDate: Date;
    maximumDate: Date;
    selectedLanguage: string;
    defaultLanguage: string
}

type Skibig3SearchWidgetSkiStayState = {
    adults: number;
    childs: number;
    smallScreen: boolean;
}

class Skibig3SearchWidgetSkiStay extends React.Component<Skibig3SearchWidgetSkiStayProps, Skibig3SearchWidgetSkiStayState> {
    /** context: ApplicationContext */
    static contextType = ApplicationContext;
    /** @ts-ignore */
    context!: React.ContextType<typeof ApplicationContext>;

    state: Skibig3SearchWidgetSkiStayState = {
        adults: 2,
        childs: 0,
        smallScreen: this.isSmall,
    }

    getLink(currency = this.context.currency?.code) {
        if (!this.context.ready) return "";
        let host = 'vacations.skibig3.com';
        if (currency === 'USD') host = 'booking.skibig3.com';
        return `https://${host}/products/lodging?search_date=${this.startDate}&search_nights=${this.numNights}&search_adults=${this.state.adults}&search_childs=${this.state.childs}&currency=${currency}`;
    }

    get startDate() {
        return DateTime.fromJSDate(this.props.startDate).toFormat("yyyy-MM-dd");
    }

    get minEndDate() {
        return DateTime.fromJSDate(this.props.startDate).plus({ day: 1 }).toJSDate();
    }

    get endDate() {
        return DateTime.fromJSDate(this.props.endDate).toFormat("MM/dd/yyyy");
    }

    get numNights() {
        const sd = DateTime.fromJSDate(this.props.startDate);
        const ed = DateTime.fromJSDate(this.props.endDate);
        const diff = sd.diff(ed, ["days"]);
        const numdays = Math.abs(diff.values.days)
        return numdays;
    }

    get isSmall() {
        if (isRunTime()) return window.innerWidth < 1024;
        return false;
    }

    onResize = () => {
        const isSm = this.isSmall;
        if (isSm !== this.state.smallScreen) {
            this.setState({smallScreen: isSm})
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResize);
        this.setState({smallScreen: this.isSmall});
    }

    componentWillUnmount(): void {
        window.removeEventListener('resize', this.onResize);
    }


    setGuests = ({childs, adults, childAges}:{childs:number[], adults:number[], childAges: number[][]}) => {
        this.setState({adults: adults[0], childs: childs[0]});
    }

    render() {
        const {startDate, setStartDate, endDate, setEndDate} = this.props;
        const translations = getSearchWidgetTranslations(this.props.selectedLanguage);

        return <>
        <div className={`bg-white flex flex-col lg:flex-row gap-4 justify-between items-center p-4 sm:p-6 rounded-b-2xl`}>
            <div className="w-full">
              <DatePicker
                label={translations.arrivalDate}
                dateFormat="MMMM dd, yyyy"
                onChange={setStartDate}
                value={startDate}
                openToDate={startDate}
                showCalendarIcon={true}
                locale={"en"}
                includeDateIntervals={[{ start: this.props.minimumDate, end: this.props.maximumDate }]}
              />
            </div>
            <div className="w-full">
              <DatePicker
                label={translations.departureDate}
                dateFormat="MMMM dd, yyyy"
                onChange={setEndDate}
                value={endDate}
                openToDate={endDate}
                showCalendarIcon={true}
                includeDateIntervals={[{ start: this.minEndDate, end: this.props.maximumDate }]}
                locale={"en"}
              />
            </div>
            <div className="w-full">
                <GuestPicker withChildAges={false} onChange={this.setGuests} translations={translations}/>
            </div>
            <div className="w-full">
                {this.context.currency
                    ? <CTAButton radius="9999px" key={this.context.currency} link={this.getLink()} color="#282828" bgcolor='#FFB200' type="primary" text="Search" icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
                    : <CTAButton radius="9999px" color="#282828" bgcolor='#FFB200' type="primary" text="Search" icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
                }
            </div>
          </div>
        </>
    }
}

type Skibig3SearchWidgetTicketsProps = {
    startDate: Date;
    numdays: number;
    setDays: (pax: number) => void;
    setStartDate: (date: Date) => void;
    minimumDate: Date;
    maximumDate: Date;
    selectedLanguage: string;
    defaultLanguage: string;
}

class Skibig3SearchWidgetTickets extends React.Component<Skibig3SearchWidgetTicketsProps> {
    /** context: ApplicationContext */
    static contextType = ApplicationContext;
    /** @ts-ignore */
    context!: React.ContextType<typeof ApplicationContext>;


    get link() {
        const currency = this.context.currency?.code || "";
        let host = 'vacations.skibig3.com';
        if (currency === "USD") host = 'booking.skibig3.com';
        return `https://${host}/products/lift-tickets/yield/results?startDate=${this.startDate}&startmonth=${this.month}&startYear=${this.year}&days=${this.props.numdays}&currency=${currency}`;
    }

    get startDate() {
        return DateTime.fromJSDate(this.props.startDate).toFormat("yyyy-MM-dd");
    }
    get month() {
        return DateTime.fromJSDate(this.props.startDate).toFormat("MM");
    }
    get year() {
        return DateTime.fromJSDate(this.props.startDate).toFormat("yyyy");
    }

    render() {
        const {startDate, setStartDate, numdays, setDays} = this.props;
        const translations = getSearchWidgetTranslations(this.props.selectedLanguage);

        return <>
        <div className={`bg-white flex flex-col lg:flex-row gap-4 justify-between items-center p-4 sm:p-6 rounded-b-2xl`}>
            <div className="w-full">
              <DatePicker
                label={translations.arrivalDate}
                dateFormat="MMMM dd, yyyy"
                onChange={setStartDate}
                value={startDate}
                openToDate={startDate}
                showCalendarIcon={true}
                includeDateIntervals={[{ start: this.props.minimumDate, end: this.props.maximumDate }]}
                locale={"en"}
              />
            </div>
            <div className="w-full">
                <div className="flex flex-row gap-3 items-center justify-around">
                    <span className="boldFontFamily searchWidgetText">Num days</span>
                    <QuantitySelector
                        quantity={numdays}
                        onPlusClick={() => setDays(numdays + 1)}
                        onMinusClick={() => setDays(numdays - 1)}
                        disabledOpacity="opacity-100"
                        min={1}
                        max={12}
                        colors={{ blocksForeground: "#000" }}
                    />
                </div>
            </div>
            <div className="w-full hidden lg:flex"></div>
            <div className="w-full">
                { this.context.currency
                    ? <CTAButton radius="9999px" link={this.link} color="#282828" bgcolor='#FFB200' type="primary" text="Search" icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
                    : <CTAButton radius="9999px" color="#282828" bgcolor='#FFB200' type="primary" text="Search" icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
                }
            </div>
        </div>
        </>
    }
}


type Skibig3SearchWidgetRentalsProps = {
    startDate: Date;
    setStartDate: (date: Date) => void;
    minimumDate: Date;
    maximumDate: Date;
    selectedLanguage: string;
    defaultLanguage: string;
}

class Skibig3SearchWidgetRentals extends React.Component<Skibig3SearchWidgetRentalsProps> {
    /** context: ApplicationContext */
    static contextType = ApplicationContext;
    /** @ts-ignore */
    context!: React.ContextType<typeof ApplicationContext>;

    get link() {
        const currency = this.context.currency?.code || "";
        let host = 'vacations.skibig3.com';
        if (currency === "USD") host = 'booking.skibig3.com';
        return `https://${host}/v2/products/rentals?startDate=${this.startDate}&currency=${currency}`;
    }

    get startDate() {
        return DateTime.fromJSDate(this.props.startDate).toFormat("yyyy-MM-dd");
    }

    render() {
        const {startDate, setStartDate} = this.props;
        const translations = getSearchWidgetTranslations(this.props.selectedLanguage);

        return <>
        <div className={`bg-white flex flex-col lg:flex-row gap-4 justify-between items-center p-4 sm:p-6 rounded-b-2xl`}>
            <div className="w-full">
              <DatePicker
                label={translations.arrivalDate}
                dateFormat="MMMM dd, yyyy"
                onChange={setStartDate}
                value={startDate}
                openToDate={startDate}
                showCalendarIcon={true}
                includeDateIntervals={[{ start: this.props.minimumDate, end: this.props.maximumDate }]}
                locale={"en"}
              />
            </div>
            <div className="w-full hidden lg:flex"></div>
            <div className="w-full hidden lg:flex"></div>
            <div className="w-full">
                { this.context.currency
                    ? <CTAButton radius="9999px" link={this.link} color="#282828" bgcolor='#FFB200' type="primary" text="Search" icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
                    : <CTAButton radius="9999px" color="#282828" bgcolor='#FFB200' type="primary" text="Search" icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
                }
            </div>
        </div>
        </>
    }
}


type Skibig3SearchWidgetLessonsProps = {
    startDate: Date;
    setStartDate: (date: Date) => void;
    minimumDate: Date;
    maximumDate: Date;
    selectedLanguage: string;
    defaultLanguage: string;
}


class Skibig3SearchWidgetLessons extends React.Component<Skibig3SearchWidgetLessonsProps> {
    /** context: ApplicationContext */
    static contextType = ApplicationContext;
    /** @ts-ignore */
    context!: React.ContextType<typeof ApplicationContext>;

    get link() {
        const currency = this.context.currency?.code || "";
        let host = 'vacations.skibig3.com';
        if (currency === "USD") host = 'booking.skibig3.com';
        return `https://${host}/v2/products/lessons?startDate=${this.startDate}&currency=${currency}`;
    }

    get startDate() {
        return DateTime.fromJSDate(this.props.startDate).toFormat("yyyy-MM-dd");
    }

    render() {
        const {startDate, setStartDate} = this.props;
        const translations = getSearchWidgetTranslations(this.props.selectedLanguage);

        return <>
        <div className={`bg-white flex flex-col lg:flex-row gap-4 justify-between items-center p-4 sm:p-6 rounded-b-2xl`}>
            <div className="w-full">
              <DatePicker
                label={translations.arrivalDate}
                dateFormat="MMMM dd, yyyy"
                onChange={setStartDate}
                value={startDate}
                openToDate={startDate}
                showCalendarIcon={true}
                includeDateIntervals={[{ start: this.props.minimumDate, end: this.props.maximumDate }]}
                locale={"en"}
              />
            </div>
            <div className="w-full hidden lg:flex"></div>
            <div className="w-full hidden lg:flex"></div>
            <div className="w-full">
                <CTAButton radius="9999px" link={this.link} color="#282828" bgcolor='#FFB200' type="primary" text="Search" icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
            </div>
        </div>
        </>
    }
}

type SearchWidgetProps = {
    selectedLanguage: string;
    defaultLanguage: string;
    removeMargin: boolean;
}

type SearchWidgetState = {
    tab: "ski&stay" | "tickets" | "rentals" | "lessons",
    startDate: Date;
    endDate: Date;
    numdays: number;
}

export default class Skibig3SearchWidget extends React.Component<SearchWidgetProps, SearchWidgetState> {

    static minimumDate() {
        const baseDate = new Date(2024,10,1, 12, 0, 0, 0);
        const today = DateTime.fromJSDate(baseDate).startOf("day").toJSDate();
        return today;
    }

    static firstSelectedDate() {
        const baseDate = new Date(2025, 0, 15, 12, 0, 0, 0);
        const today = DateTime.fromJSDate(baseDate).startOf("day").toJSDate();
        return today;
    }

    static getEndDate() {
        const baseDate = new Date(2025, 0, 22, 12, 0, 0, 0);
        const future = DateTime.fromJSDate(baseDate).startOf("day").toJSDate();
        return future;
    }

    static maximumDate() {
        const baseDate = new Date();
        const nextYears = DateTime.fromJSDate(baseDate).startOf("day").plus({ year: 2 }).startOf("day").toJSDate();
        return nextYears;
    }

    state: SearchWidgetState = {
        tab: "ski&stay",
        startDate: Skibig3SearchWidget.firstSelectedDate(),
        endDate: Skibig3SearchWidget.getEndDate(),
        numdays: 1,
    }

    setActiveTab = (tab: any) => {
        this.setState({tab});
    }

    setNumDays = (days: number) => {
        this.setState({numdays: days});
    }

    setStartDate = (date: Date) => {
        const ts = date.getTime();
        const ets = this.state.endDate.getTime();
        if (ts > ets) {
            const plus1 = DateTime.fromJSDate(date).plus({day: 1}).toJSDate()
            this.setState({startDate: date, endDate: plus1});
        } else {
            this.setState({startDate: date});
        }
    }
    setEndDate = (date: Date) => {
        this.setState({endDate: date});
    }

    render() {
        return <>
        <div className={`${this.props.removeMargin ? "" : "mt-[-90px]"} mt-[-90px] flex w-full justify-center lg:px-10 relative z-[2] flex-col`} style={{ filter: "drop-shadow(0px 2px 15px rgba(37, 37, 39, 0.15))" }}>
            <div className="w-[95%] sm:max-w-6xl justify-center m-auto flex flex-col">
                <Skibig3SearchWidgetTabs activeTab={this.state.tab} setActiveTab={this.setActiveTab} />

                {this.state.tab === 'ski&stay' ? <Skibig3SearchWidgetSkiStay
                    startDate={this.state.startDate}
                    setStartDate={this.setStartDate}
                    endDate={this.state.endDate}
                    setEndDate={this.setEndDate}
                    minimumDate={Skibig3SearchWidget.minimumDate()}
                    maximumDate={Skibig3SearchWidget.maximumDate()}
                    selectedLanguage={this.props.selectedLanguage}
                    defaultLanguage={this.props.defaultLanguage}
                     /> : null}

                {this.state.tab === 'tickets' ? <Skibig3SearchWidgetTickets
                    startDate={this.state.startDate}
                    setStartDate={this.setStartDate}
                    numdays={this.state.numdays}
                    setDays={this.setNumDays}
                    minimumDate={Skibig3SearchWidget.minimumDate()}
                    maximumDate={Skibig3SearchWidget.maximumDate()}
                    selectedLanguage={this.props.selectedLanguage}
                    defaultLanguage={this.props.defaultLanguage}
                    /> : null}

                {this.state.tab === 'rentals' ? <Skibig3SearchWidgetRentals
                    startDate={this.state.startDate}
                    setStartDate={this.setStartDate}
                    minimumDate={Skibig3SearchWidget.minimumDate()}
                    maximumDate={Skibig3SearchWidget.maximumDate()}
                    selectedLanguage={this.props.selectedLanguage}
                    defaultLanguage={this.props.defaultLanguage}
                    /> : null}

                {this.state.tab === 'lessons' ? <Skibig3SearchWidgetLessons
                    startDate={this.state.startDate}
                    setStartDate={this.setStartDate}
                    minimumDate={Skibig3SearchWidget.minimumDate()}
                    maximumDate={Skibig3SearchWidget.maximumDate()}
                    selectedLanguage={this.props.selectedLanguage}
                    defaultLanguage={this.props.defaultLanguage}
                    /> : null}

            </div>
        </div>
        </>
    }

}